<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import Footer from '@/components/Footer.vue'
import Navbar from '@/components/Navbar.vue'
import Sidebar from '@/components/Sidebar.vue'

const collapsed = ref(false)
const openKeys = ref<string[]>([])
const isMobile = ref(false)
const drawerOpen = ref(false)

function checkMobile() {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
</script>

<template>
  <a-layout class="app-root">
    <!-- Desktop: collapsible sider -->
    <Sidebar
      v-if="!isMobile"
      v-model:collapsed="collapsed"
      v-model:openKeys="openKeys"
      class="sidebar"
    />

    <!-- Mobile: drawer -->
    <a-drawer
      v-if="isMobile"
      :open="drawerOpen"
      placement="left"
      width="auto"
      :body-style="{ padding: 0 }"
      :header-style="{ display: 'none' }"
      @close="drawerOpen = false"
    >
      <Sidebar
        :collapsed="false"
        v-model:openKeys="openKeys"
        @menuClick="
          (key) => {
            if (key.startsWith('/')) drawerOpen = false
          }
        "
      />
    </a-drawer>

    <a-layout class="main-panel">
      <Navbar
        v-model:collapsed="collapsed"
        :is-mobile="isMobile"
        style="flex-shrink: 0"
        @open-drawer="drawerOpen = true"
      />
      <a-layout-content class="content">
        <div class="content-inner">
            <router-view />
        </div>
      </a-layout-content>
      <Footer style="flex-shrink: 0" />
    </a-layout>
  </a-layout>
</template>

<style scoped>
.app-root {
  min-height: 100vh;
}
.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  align-self: flex-start;
}
.main-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
}
.content {
  flex: 1;
}
.content-inner {
  padding: 16px;
}
</style>
